import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { stepActions } from "../../store/Steps";

import { useTranslation } from "react-i18next";
import playstoreMtek from "../../../assets/images/click-to-download.svg";
import { DOMAIN_THEME_PREFIX_BOLTTECH, DOMAIN_THEME_PREFIX_MTEK } from "../../enums/prefix";
import user2 from "../../../assets/images/user2.png";
import powerByIcon from "../../../assets/images/powered-by-bolttech.svg";



function Header() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isNavOpen, setIsNavOpen] = useState(false);
    
    const hostname = window.location.hostname.toLowerCase();
    const isMtekOrBolttech = hostname.includes(DOMAIN_THEME_PREFIX_MTEK) || hostname.includes(DOMAIN_THEME_PREFIX_BOLTTECH);
    const displayEmail = localStorage.getItem("email")!;
    const userEmail = sessionStorage.getItem("email")!;
    const displayName = localStorage.getItem("userName")!;
    const username = sessionStorage.getItem("userName")!;
    const dname = displayName ? displayName : username;
    const email = displayEmail ? displayEmail : userEmail;
    const isLoggedIn = Boolean(dname || email);
    const authLabel = dname || email || t("header.signIn");

    const onSignOut = () => {
        sessionStorage.removeItem("userName");
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
    };

    const onLogoClick = () => {
        dispatch(stepActions.onRestartCurrentStepToDefault());
        sessionStorage.removeItem("payment-screen");
        sessionStorage.setItem("onGetStarted", "false");
        setIsNavOpen(false);
        navigate("/")
    };

    const onDesktopAuthClick = () => {
        if (isLoggedIn) {
            onSignOut();
            return;
        }
        navigate("/login");
    };

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <header className="steps-header">
            <nav className="navbar navbar-expand-lg steps-navbar px-0">
                <button
                    type="button"
                    className="navbar-brand steps-logo-btn p-0 border-0 bg-transparent"
                    onClick={onLogoClick}
                >
                    <img alt="Mtek logo" className="steps-logo mtek-logo" />
                </button>

                <button
                    className="navbar-toggler steps-navbar-toggler ms-auto"
                    type="button"
                    aria-controls="stepsNavbarContent"
                    aria-expanded={isNavOpen}
                    aria-label="Toggle navigation"
                    onClick={() => setIsNavOpen((current) => !current)}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    id="stepsNavbarContent"
                    className={`collapse navbar-collapse justify-content-end ${isNavOpen ? "show" : ""}`}
                >
                    <div className="steps-nav-actions ms-auto d-flex align-items-center">
                        <select 
                            className="form-select form-select-sm me-3" 
                            style={{ width: "auto" }} 
                            onChange={(e) => changeLanguage(e.target.value)} 
                            value={i18n.language}
                        >
                            <option value="en">English</option>
                            <option value="sw">Kiswahili</option>
                            <option value="am">Amharic</option>
                        </select>
                        <div
                            onClick={onDesktopAuthClick}
                            className="auth-mgmt-btn gap-2 d-none d-lg-inline-flex"
                            title={authLabel}
                        >
                            <img src={user2} alt="user" />
                            <span>{authLabel}</span>
                        </div>
                        <div
                            onClick={onDesktopAuthClick}
                            className="auth-mgmt-btn gap-2 d-inline-flex d-lg-none"
                            title={authLabel}
                        >
                            <img src={user2} alt="user" />
                            <span>{authLabel}</span>
                        </div>
                        {isMtekOrBolttech ? (
                            <>
                                <a
                                    href="https://bit.ly/3FprVBJ"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="steps-download-link d-none d-lg-inline-flex"
                                >
                                    <div className="steps-download-content">
                                        <img className="steps-download-image" src={playstoreMtek} alt="Download on Play Store" />
                                        <div className="playstore-click-to-download">{t("header.clickToDownload")}</div>
                                    </div>
                                </a>
                                <a
                                    href="https://bit.ly/3FprVBJ"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="steps-download-link steps-download-link-mobile d-lg-none"
                                >
                                    <div className="steps-download-content">
                                        <img className="steps-download-image" src={playstoreMtek} alt="Download on Play Store" />
                                        <div className="playstore-click-to-download">{t("header.clickToDownload")}</div>
                                    </div>
                                </a>
                            </>
                        ) : (
                            <div className="powered-by-header d-flex align-items-center ms-3">
                                <img src={powerByIcon} alt="Powered by" style={{ height: "15px" }} />
                            </div>
                        )}
                    </div>
                </div>
            </nav>
            </header>
    );
}

export default Header;